import clsx from "clsx";
import type { ReactNode } from "react";

import { useIsMounted } from "@/lib/dom";

import { Switch, type SwitchProps } from "../../switch";
import type { FieldProps } from "./shared";

export type SwitchFieldProps = Omit<FieldProps, "label"> &
  SwitchProps & { label: ReactNode };

export function SwitchField({
  className,
  description,
  placeholder,
  field,
  ...props
}: SwitchFieldProps) {
  const isMounted = useIsMounted();

  return (
    <Switch
      {...props}
      className={clsx("flex flex-row gap-2", className)}
      name={field.name}
      isSelected={field.state.value ?? false}
      onChange={field.handleChange}
      onBlur={field.handleBlur}
      isDisabled={!isMounted || props.isDisabled}
    />
  );
}
